import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../services/i18nService';

import styles from './capturedevice.scss';

class NextButton extends React.PureComponent {
    static propTypes = {
        onNext: PropTypes.func.isRequired,
    };

    render() {
        const { onNext } = this.props;

        return (
            <button
                className={`${styles.button} btn`}
                onClick={onNext}
            >
                <i className="fa fa-arrow-right" aria-hidden />
                {t('navigation.next')}
            </button>
        );
    }
}

export default NextButton;
